module.exports = __webpack_public_path__ + "img/logo.99989d10.svg";